export const BUILDER_LANDING_PAGE_MODEL_NAME = "landing-page";
